export default __webpack_public_path__ + "static/media/chatBg.392854ed.png";